module.exports = __webpack_public_path__ + "media/images/bizx-award-5ba8b594a882fa170cd5d4377576551f.png";